export class MainNavigation {
  constructor(root) {
    this.root = root;
    this.toggle = root.querySelector('.main-nav-toggle');
    this.menu = root.querySelector('.main-nav-menu');
    this.onToggle = () => this.setOpen(this.menu.hidden, true);
    this.onOutside = event => {
      if (!this.menu.hidden && !this.menu.contains(event.target) && !this.toggle.contains(event.target)) {
        this.setOpen(false);
      }
    };
    this.onKey = event => {
      if (event.key === 'Escape' && !this.menu.hidden) {
        event.preventDefault();
        this.setOpen(false, true);
      }
    };
    this.onNavigate = event => {
      if (event.target.closest('a')) this.setOpen(false);
    };
    this.setOpen(false);
    this.resizeObserver = new ResizeObserver(() => {
      const height = root.querySelector('.main-nav-header').getBoundingClientRect().height;
      root.style.setProperty('--main-nav-height', `${height}px`);
    });
    this.resizeObserver.observe(root.querySelector('.main-nav-header'));
    this.toggle.addEventListener('click', this.onToggle);
    this.menu.addEventListener('click', this.onNavigate);
    document.addEventListener('click', this.onOutside);
    document.addEventListener('keydown', this.onKey);
  }

  setOpen(open, focus = false) {
    this.menu.hidden = !open;
    this.toggle.setAttribute('aria-expanded', String(open));
    if (focus) {
      if (open) this.menu.querySelector('a, button')?.focus();
      else this.toggle.focus();
    }
  }

  dispose() {
    this.setOpen(false);
    this.resizeObserver.disconnect();
    this.toggle.removeEventListener('click', this.onToggle);
    this.menu.removeEventListener('click', this.onNavigate);
    document.removeEventListener('click', this.onOutside);
    document.removeEventListener('keydown', this.onKey);
  }
}

let navigation;
function cleanup() {
  navigation?.dispose();
  navigation = undefined;
}
document.addEventListener('turbo:load', () => {
  cleanup();
  const root = document.querySelector('[data-main-navigation]');
  if (root) navigation = new MainNavigation(root);
});
document.addEventListener('turbo:before-cache', cleanup);
document.addEventListener('turbo:before-render', cleanup);
